import { render, staticRenderFns } from "./AsignarColonias.vue?vue&type=template&id=1162d354&"
import script from "./AsignarColonias.vue?vue&type=script&lang=js&"
export * from "./AsignarColonias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports